import { useEffect, useState } from "react";
import { server } from "../../server";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";

function UpdateBook() {
  const [formData, setFormData] = useState({
    title: "",
    bookNo: "",
    bookType: "",
    language: "",
    isbnNo: "",
    class: "",
    subject: "",
    rackNo: "",
    publisher: "",
    author: "",
    totalQuantity: "",
    availableQuantity: "",
    description: "",
    purchase: {
      billDate: "",
      billNo: "",
      purchasedFrom: "",
    },
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const bookId = location.state?.bookId;

  useEffect(() => {
    const fetchBook = async () => {
      try {
        const response = await axios.post(
          "https://7otfgyv0ke.execute-api.ap-south-1.amazonaws.com/prod/library_data_mongodb",
          { bookId }
        );
        const book = response?.data?.["body-json"]?.body?.data?.[0];

        if (book) {
          setFormData({
            title: book.title || "",
            bookNo: book.bookNo || "",
            bookType: book.bookType || "",
            language: book.language || "",
            isbnNo: book.isbnNo || "",
            class: book.class || "",
            subject: book.subject || "",
            rackNo: book.rackNo || "",
            publisher: book.publisher || "",
            author: book.author || "",
            totalQuantity: book.totalQuantity || "",
            availableQuantity: book.availableQuantity || "",
            description: book.description || "",
            purchase: {
              billDate: book.purchase?.billDate || "",
              billNo: book.purchase?.billNo || "",
              purchasedFrom: book.purchase?.purchasedFrom || "",
            },
          });
        } else {
          toast.error("Book data not found");
        }
      } catch (err) {
        console.error(err);
        toast.error("Error fetching book details");
      } finally {
        setFetching(false);
      }
    };

    fetchBook();
  }, [bookId, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePurchaseChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      purchase: {
        ...prev.purchase,
        [name]: value,
      },
    }));
  };

  const countFilledFields = (fields) => {
    return String(
      fields.filter((field) => formData[field].trim() !== "").length
    ).padStart(2, "0");
  };

  const getTotalFields = (fields) => {
    return String(fields.length).padStart(2, "0");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const updatePayload = {
        bookId: bookId,
        ...formData,
      };

      const response = await axios.post(
        `${server}/library_update_mongodb`,
        updatePayload,
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.data?.success) {
        toast.success("Book Updated", {
          position: "top-right",
        });
        navigate("/book-list");
      } else {
        toast.error("Please Try Again", {
          position: "top-right",
        });
      }
    } catch (error) {
      toast.error("Please Try Again", {
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div className="">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-12">
                  <div class="m-3 mt-2 pt-1 d-flex justify-content-between">
                    <div class="d-flex align-items-center mt-2">
                      <span
                        onClick={() => window.history.back()}
                        class="back-button me-3 cursor-pointer"
                      >
                        <i className="bi bi-arrow-left fs-3"></i>
                      </span>
                      <nav aria-label="breadcrumb">
                        <h4 className="m-0 lh-sm">Add Book</h4>
                        <ol class="breadcrumb pe-3 lh-sm">
                          <li class="breadcrumb-item">
                            <a href="#">Library</a>
                          </li>
                          <li class="breadcrumb-item">
                            <a href="#">Book List</a>
                          </li>
                          <li
                            class="breadcrumb-item active"
                            aria-current="page"
                          >
                            Add Book
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="container-fluid">
              <div className="row g-2">
                <div className="col-lg-8">
                  <form onSubmit={handleSubmit}>
                    <div class="px-5 py-3 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingOne">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-controls="collapseOne"
                            >
                              <span class="me-auto fs-5">
                                1. Book Details{" "}
                                <span className="ms-3 text-secondary"></span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span class="badge bg-secondary-soft me-3 px-3">
                                  Locked
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseOne"
                            class="collapse"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              {/* Title */}
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Title
                                </label>
                                <input
                                  type="text"
                                  className="form-control text-dark"
                                  name="title"
                                  placeholder="Enter book title"
                                  value={formData.title}
                                  onChange={handleChange}
                                  required
                                />
                              </div>

                              {/* Book No */}
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Book No
                                </label>
                                <input
                                  type="text"
                                  className="form-control text-dark"
                                  name="bookNo"
                                  placeholder="Enter book number"
                                  value={formData.bookNo}
                                  onChange={handleChange}
                                  required
                                />
                              </div>

                              {/* Book Type */}
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Book Type
                                </label>
                                <input
                                  type="text"
                                  className="form-control text-dark"
                                  name="bookType"
                                  placeholder="e.g., Reference, Fiction"
                                  value={formData.bookType}
                                  onChange={handleChange}
                                  required
                                />
                              </div>

                              {/* Language */}
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Language
                                </label>
                                <input
                                  type="text"
                                  className="form-control text-dark"
                                  name="language"
                                  placeholder="Enter language of the book"
                                  value={formData.language}
                                  onChange={handleChange}
                                  required
                                />
                              </div>

                              {/* ISBN No */}
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  ISBN No
                                </label>
                                <input
                                  type="text"
                                  className="form-control text-dark"
                                  name="isbnNo"
                                  placeholder="Enter ISBN number"
                                  value={formData.isbnNo}
                                  onChange={handleChange}
                                  required
                                />
                              </div>

                              {/* Class */}
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Class
                                </label>
                                <input
                                  type="text"
                                  className="form-control text-dark"
                                  name="class"
                                  placeholder="Enter class/grade level"
                                  value={formData.class}
                                  onChange={handleChange}
                                  required
                                />
                              </div>

                              {/* Subject */}
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Subject
                                </label>
                                <input
                                  type="text"
                                  className="form-control text-dark"
                                  name="subject"
                                  placeholder="Enter subject"
                                  value={formData.subject}
                                  onChange={handleChange}
                                  required
                                />
                              </div>

                              {/* Rack No */}
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Rack No
                                </label>
                                <input
                                  type="text"
                                  className="form-control text-dark"
                                  name="rackNo"
                                  placeholder="Enter rack number"
                                  value={formData.rackNo}
                                  onChange={handleChange}
                                  required
                                />
                              </div>

                              {/* Publisher */}
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Publisher
                                </label>
                                <input
                                  type="text"
                                  className="form-control text-dark"
                                  name="publisher"
                                  placeholder="Enter publisher name"
                                  value={formData.publisher}
                                  onChange={handleChange}
                                  required
                                />
                              </div>

                              {/* Author */}
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Author
                                </label>
                                <input
                                  type="text"
                                  className="form-control text-dark"
                                  name="author"
                                  placeholder="Enter author name"
                                  value={formData.author}
                                  onChange={handleChange}
                                  required
                                />
                              </div>

                              {/* Total Quantity */}
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Total Quantity
                                </label>
                                <input
                                  type="number"
                                  className="form-control text-dark"
                                  name="totalQuantity"
                                  placeholder="Enter total quantity"
                                  value={formData.totalQuantity}
                                  onChange={handleChange}
                                />
                              </div>

                              {/* Available Quantity */}
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Available Quantity
                                </label>
                                <input
                                  type="number"
                                  className="form-control text-dark"
                                  name="availableQuantity"
                                  placeholder="Enter available quantity"
                                  value={formData.availableQuantity}
                                  onChange={handleChange}
                                />
                              </div>

                              {/* Description */}
                              <div className="col-12">
                                <label className="form-label mb-1 ms-3">
                                  Description
                                </label>
                                <textarea
                                  className="form-control text-dark"
                                  name="description"
                                  placeholder="Enter a brief description of the book"
                                  value={formData.description}
                                  onChange={handleChange}
                                  rows="4"
                                  required
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingTwo">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo"
                              aria-controls="collapseTwo"
                            >
                              <span class="me-auto fs-5">
                                2. Purchase Details{" "}
                                <span className="ms-3 text-secondary"></span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span class="badge bg-secondary-soft me-3 px-3">
                                  Locked
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseTwo"
                            class="collapse"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              {/* Bill Date */}
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Bill Date
                                </label>
                                <input
                                  type="date"
                                  className="form-control text-dark"
                                  name="billDate"
                                  value={formData.purchase?.billDate || ""}
                                  onChange={handlePurchaseChange}
                                />
                              </div>

                              {/* Bill No */}
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Bill No
                                </label>
                                <input
                                  type="text"
                                  className="form-control text-dark"
                                  name="billNo"
                                  placeholder="Enter bill number"
                                  value={formData.purchase?.billNo || ""}
                                  onChange={handlePurchaseChange}
                                />
                              </div>

                              {/* Purchased From */}
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Purchased From
                                </label>
                                <input
                                  type="text"
                                  className="form-control text-dark"
                                  name="purchasedFrom"
                                  placeholder="Enter purchased from"
                                  value={formData.purchase?.purchasedFrom || ""}
                                  onChange={handlePurchaseChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="my-3 d-flex float-end me-5">
                      <button type="submit" class="btn btn-success mt-2 px-6">
                        {loading ? (
                          <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                          ></div>
                        ) : (
                          "Update"
                        )}
                      </button>
                    </div>
                  </form>
                </div>

                <div className="col-lg-4">
                  <div class="p-5 bg-white rounded-4 sticky-top top-10 z-1">
                    <div className="d-flex flex-column align-items-center">
                      <div>
                        <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative me-2">
                          <span class="position-absolute mt-2">
                            <i class="bi bi-image fs-2"></i>
                          </span>
                          <input
                            class="form-control border-0 opacity-0"
                            type="file"
                          />
                        </div>
                        <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative">
                          <img
                            src="https://cdn-icons-png.flaticon.com/512/14021/14021384.png"
                            className="w-100 position-absolute p-2 rounded-4"
                            alt="QR"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default UpdateBook;
